require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/fn/regexp/escape.js
// module id = 1303
// module chunks = 0